import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseTypeDoc, TypeDocumentIF, UpdateTypeDocument, BodyTypeDoc, GetAllTypeDoc } from '../interfaces/type-document.interface';
import { CoreService } from 'src/app/shared/services/core-service.service';

@Injectable({providedIn: 'root'})
export class DocumentService {

  private baseUrl: string = environment.baseUrlAuth;
  private baseUrlJS: string = environment.baseUrl;

  private http =          inject(HttpClient);
  private _coreService =  inject(CoreService);

  private getAuthHeaders(): { headers: HttpHeaders; params: HttpParams } {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type':   'application/json',
      'Authorization':  `Bearer ${authToken}`,
    });

    const params = new HttpParams().set('like', 'true').set('limitMax', '20');

    return { headers, params };
  }

  // getDocument(): Observable<GetAllTypeDoc> {
  //   const apiUrl = `${this.baseUrl}/api/tipos-documentos`;
  //   const { headers } = this.getAuthHeaders();

  //   // Usar timer para crear una pausa de 5 segundos
  //   const delayObservable = timer(5000);

  //   return delayObservable.pipe(
  //     switchMap(() => {
  //       // Realizar la solicitud original después de 5 segundos
  //       return this.http.get<GetAllTypeDoc>(apiUrl, { headers, params: new HttpParams().set('limit', '400').set('offset', '0') })
  //         .pipe(
  //           catchError((err) => {
  //             this._coreService.openErrorSnackbar(`${err.error.message}`, 'Ok');
  //             console.log(err);
  //             return throwError(() => err);
  //           }),
  //           // Agregar operador tap para realizar acciones después de la solicitud, como validar
  //           tap((response) => {
  //             // Realizar validaciones aquí con la respuesta si es necesario
  //           })
  //         );
  //     })
  //   );
  // }

  getDocument(): Observable<GetAllTypeDoc> {
    const apiUrl = `${this.baseUrl}/api/tipos-documentos`;
    const { headers } = this.getAuthHeaders();

    // Realizar una solicitud previa para obtener la cantidadTotal
    return this.http
      .get<GetAllTypeDoc>(apiUrl, { headers, params: new HttpParams().set('limit', '1').set('offset', '0') })
      .pipe(
        switchMap((response) => {
          // Verificar si la respuesta contiene la propiedad "cantidadTotal"
          if (response && response.catidadTotal) {
            const cantidadTotal = response.catidadTotal;
            // Actualizar el valor de "limit" según la cantidadTotal
            const params = new HttpParams().set('limit', cantidadTotal.toString()).set('offset', '0');
            // Realizar la solicitud final con el valor de "limit" actualizado
            return this.http.get<GetAllTypeDoc>(apiUrl, { headers, params });
          } else {
            // Si no se encuentra "cantidadTotal" en la respuesta, continuar con la solicitud original
            return this.http.get<GetAllTypeDoc>(apiUrl, { headers, params: new HttpParams().set('limit', '400').set('offset', '0') });
          }
        }),
        catchError((err) => {
          this._coreService.openErrorSnackbar(`${err.error.message}`, 'Ok');
          console.error(err);
          return throwError(() => err);
        })
      );
  }

  getDocumentByID(id: string): Observable<TypeDocumentIF[]> {
    const apiUrl = `${this.baseUrl}/api/tipos-documentos/${id}`;
    const { headers, params } = this.getAuthHeaders();

    return this.http.get<TypeDocumentIF[]>(apiUrl, {params, headers })
  }

  getDocumentByNit(id: string): Observable<ResponseTypeDoc> {
    const apiUrl = `${this.baseUrl}/api/tipos-documentos/${id}`;
    const { headers } = this.getAuthHeaders();

    return this.http.get<ResponseTypeDoc>(apiUrl, {headers})
  }

  postDocument(body: BodyTypeDoc): Observable<ResponseTypeDoc> {
    const apiUrl = `${this.baseUrl}/api/tipos-documentos`;
    const { headers } = this.getAuthHeaders();

    return this.http.post<ResponseTypeDoc>(apiUrl, body, {headers})
  }

  patchDocument(id: string, body: BodyTypeDoc): Observable<UpdateTypeDocument> {
    const apiUrl = `${this.baseUrl}/api/tipos-documentos/${id}`;
    const { headers } = this.getAuthHeaders();

    return this.http.patch<UpdateTypeDocument>(apiUrl, body, {headers}).pipe(
      catchError( err => {
        this._coreService.openErrorSnackbar(`${err.message}`, 'Ok');
        console.error(err);
        return throwError(() => err)
      })
    )

  }






}
